module.exports = __webpack_public_path__ + "img/teamslogo.722c34b0.png";